import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SidePanel, SidePanelBody, SidePanelHeader, SidePanelFooter } from '@gpstrackit/gtc-react-controls';
import { NotificationManager } from 'Components/Notifications';
import moment from 'moment';
import { Pie } from 'react-chartjs-2';
import { usePagination } from 'Components/uiControls/Table/hooks';
import { GetFormatForMoment } from 'Core/data/Helpers';

import { ColorsToRoutePointsOnRoutesTracker } from  '../../../../../../components/Map/providers/enums'

import {
    LineController,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    LineElement
  } from 'chart.js';

  import ChartJS from 'chart.js/auto';
  
  ChartJS.register(
    LineController,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    LineElement
  
  );

import {
    Grid
} from '@mui/material';

import { Button, TableView, Input, Icons, Switch, IconButton, /* DragAndDrop as DragDropList, */ MenuComponent } from '@gpstrackit/gtc-react-controls';

import {Timezone} from '../../../../../../components/uiControls'

import { useIntl } from 'react-intl';

import {
    openModalRoutesTrackerStopsVisited,
    routesTrackerGetRoute
  } from 'Redux/actions';

import './style.scss';

const ModalRouteStopVisited = (props) => {


    const { messages, locale } = useIntl();

    //const [dataPie, setDataPie] = useState(data)

    const [rowsPerPage, setRowsPerPage] = useState(10);

    const open = useSelector(state => state.routesTrackerModalStopsVisitedRedux?.open);
    const routeId = useSelector(state => state.routesTrackerModalStopsVisitedRedux?.routeId);
    const route = useSelector(state => state.routesTrackerModalStopsVisitedRedux?.route);
    const loading = useSelector(state => state.routesTrackerModalStopsVisitedRedux?.loading);
    const timeZoneUser = useSelector((state) => state.securityRedux.user.timeZone);
    const user = useSelector(state => state.securityRedux.user);
    
    const routesTableRef = useRef();
    const pagination = usePagination(routesTableRef, routesTrackerGetRoute, {id: routeId});

    const colorPending = ColorsToRoutePointsOnRoutesTracker.find(item => item.name == "Pending").color;
    const colorDone =  ColorsToRoutePointsOnRoutesTracker.find(item => item.name == "Done").color;

    const dispatch = useDispatch()

    const handleToggle = () => {
        dispatch(openModalRoutesTrackerStopsVisited({open: false}));
    }

    useEffect(()=> {
        dispatch(routesTrackerGetRoute({ id: routeId}))
    },[routeId])

    const getDate = (dateIn, timezone) => {
        let date = moment(dateIn)
        if (!date.isValid()) {
            if (dateIn && dateIn.length > 10) {
                date = moment.unix(Number(dateIn?.substring(0, dateIn.length - 3)))
            } else {
                date = moment.unix(Number(dateIn))
            }
        }
    
        if(timezone){
            date = date.tz(timezone);
        }
    
        return date;
    }

    const ItemStatusChangeLog = (props) => {
        const { label, isColumn } = props
        return (
            <div className={isColumn ? 'routesTraker-stop-visited-item-card-content' : 'routesTraker-stop-visited-item-card-content-row'}>
                <label className="routesTraker-stop-visited-label">{label}:</label>
                {props.children}
            </div>
        )
    }

    const CardStopVisited = ({ name, address, departureTime, arrivalTime }) => {
        //const { name, address, departureTime, arrivalTime } = props

        let dateDepartureTime = getDate(departureTime, timeZoneUser);
        let dateArrivalTime = getDate(arrivalTime, timeZoneUser);

        return(
            <div className="routesTraker-stop-visited-card">
                <div className="routesTraker-stop-visited-card-content">
                    <ItemStatusChangeLog isColumn label={messages['fsmRoute_routesTracker_modalStopVisited_name']} >
                        <div style={{ width: 220 }}>
                            <label>
                                {name || address}
                            </label>
                        </div>
                    </ItemStatusChangeLog>
                    <div style={{ paddingBottom: 10 }}></div>
                    <ItemStatusChangeLog label={messages['fsmRoute_routesTracker_modalStopVisited_departureTime']}>
                        <div style={{ width: 220 }}>
                        {
                            departureTime && dateDepartureTime.isValid()
                            ?
                            <Fragment>
                                <Timezone
                                    //oneControl
                                    onlyHour
                                    date={departureTime}
                                    dateFormat={""}
                                    timeFormat={`${GetFormatForMoment(user.dateformat)}  h:mm a`}
                                    timezone={timeZoneUser}
                                    className="routes-tracker-TimeZoneClassName"
                                    fromNow={true}
                                    lang={locale}
                                />
                            </Fragment>
                            :
                            <Fragment><label style={{ color: '#929292' }}>{messages['fsmRoute_routesTracker_modalStopVisited_unassigned']}</label></Fragment>
                        }
                        </div>
                    </ItemStatusChangeLog>
                    <ItemStatusChangeLog label={messages['fsmRoute_routesTracker_modalStopVisited_arrivalTime']}>
                        <div style={{ width: 220 }}>
                        {
                            arrivalTime && dateArrivalTime.isValid()
                            ?
                            <Fragment>
                                <Timezone
                                    //oneControl
                                    onlyHour
                                    date={arrivalTime}
                                    dateFormat={""}
                                    timeFormat={`${GetFormatForMoment(user.dateformat)}  h:mm a`}
                                    timezone={timeZoneUser}
                                    className="routes-tracker-TimeZoneClassName"
                                    fromNow={true}
                                    lang={locale}
                                />
                            </Fragment>
                            :
                            <Fragment><label style={{ color: '#929292' }}>{messages['fsmRoute_routesTracker_modalStopVisited_unassigned']}</label></Fragment>
                        }
                        </div>
                    </ItemStatusChangeLog>
                    
                </div>
            </div>
        )
    }
    
    const dataPie = {
        labels: [
            messages['fsmRoute_routesTracker_modalStopVisited_pending'],
            messages['fsmRoute_routesTracker_modalStopVisited_visited']],
        datasets: [
          {
            data: [route?.stopsPendingCount , route?.stopsCompletedCount],
            backgroundColor: [colorPending, colorDone],
            hoverBackgroundColor: [colorPending, colorDone],
          },
        ],
      };
    
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: messages['fsmRoute_routesTracker_modalStopVisited_progress'],
        },
    };

    return (
        <div id='idPanelRouteModal'>
        <SidePanel
            isOpen={open}
            onToggle={handleToggle}
            hiddenButton={false}
            style={{ width: '400px', transform: 'translateX(800px)' }}
        >
            <SidePanelHeader>
                <h2 style={{ margin: 0, fontFamily: '"Outfit",sans-serif' }}>{messages['fsmRoute_routesTracker_modalStopVisited_title']}</h2>
            </SidePanelHeader>
            <SidePanelBody style={{ height: '90%' }}>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    }}
                >
                    <div style={{ width: '100%' }}>
                        <div>
                            <Pie data={dataPie} options={options} />
                        </div>
                        <div style={{ height: '80%'}}>
                            {
                                route?.points?.length && route.points.map((item) => {
                                    return(
                                        <CardStopVisited {...item}></CardStopVisited>
                                    )
                                })
                            }
                        
                        </div>
                    </div>
                </div>
            </SidePanelBody>
            <SidePanelFooter>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    }}
                >
                    <Button
                        variant="secondary"
                        style={{ marginRight: 8 }}
                        onClick={handleToggle}
                    >
                        {messages['fsmRoute_routesTracker_modalStopVisited_close']}
                    </Button>
                </div>
            </SidePanelFooter>
        </SidePanel>
        </div>
    )
}




export default ModalRouteStopVisited;
